import { render } from "./AdminCreateTicket.vue?vue&type=template&id=5dc971de&scoped=true"
import script from "./AdminCreateTicket.vue?vue&type=script&lang=js"
export * from "./AdminCreateTicket.vue?vue&type=script&lang=js"

import "./AdminCreateTicket.vue?vue&type=style&index=0&id=5dc971de&scoped=true&lang=css"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukatta_Gov_Eticket\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc971de"]])

export default __exports__